import { render, staticRenderFns } from "./learnSmartRegister.vue?vue&type=template&id=06af6d0d&"
import script from "./learnSmartRegister.vue?vue&type=script&lang=js&"
export * from "./learnSmartRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports